<!-- 下拉 -->
<template>
  <div class="zlr-dropdown">
    <img :src="userAvatar"
         alt="头像"
         @click.stop="isShow=!isShow">
    <div v-show="isShow">
      <ul>
        <li v-if="isFillMore">
          <a @click="linkHandle('personal-own')">Basic Info</a>
        </li>
        <li v-if="isPaymentInfo">
          <a @click="linkHandle('personal-payment')">Payment</a>
        </li>
        <li v-if="userRole">
          <a @click="linkHandle('apply-select')">Apply mentor</a>
        </li>
        <li v-if="isPaymentInfo">
          <a @click="linkHandle('choose-type')">Switch mentor type</a>
        </li>
        <li>
          <a @click="linkHandle('personal-modify-pwd')">Change password</a>
        </li>
        <li @click="modalOmVideo=true">Try the video chat</li>
        <li @click="logoutHandle">Log out</li>
      </ul>
    </div>
    <!-- 视频弹窗 -->
    <div v-if="modalOmVideo">
        <Modal v-model="modalOmVideo"
               title="Try the video chat"
               :closable="false"
               :mask-closable="false"
               width="960">
               <om-trtc-video  @close="modalOmVideo=false"></om-trtc-video>
               <div slot="footer"></div>
        </Modal>
    </div>
  </div>
</template>

<script>
// images
import logo from '@/assets/Logo.svg'
// less
import './dropdown.less'
import { mapActions, mapState } from 'vuex'
// om视频聊天
import omTrtcVideo from './component/trtc/om-trtc-video'
export default {
  name: 'zlr-dropdown',
  components: {
    omTrtcVideo
  },
  data () {
    return {
      logo,
      isShow: false,
      // 视频聊天
      modalOmVideo: false
    }
  },
  computed: {
    ...mapState({
      'isFillMore' (state) {
        return state.user.isFillMore
      },
      'isPaymentInfo' (sate) {
        return sate.user.isPaymentInfo
      },
      userAvatar (state) {
        return state.user.userAvatar
      },
      userRole (state) {
        return state.user.userRole
      }
    })
  },
  mounted () {
    let self = this
    document.body.addEventListener('click', function (event) {
      self.isShow = false
    })
  },
  methods: {
    ...mapActions(['handleLogOut']),
    logoutHandle () {
      this.handleLogOut().then(res => {
        this.$router.push({
          name: 'login'
        })
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    },
    linkHandle (name) {
      this.$router.push({
        name
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
